'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _EntypoIcon = require('../EntypoIcon');

var _EntypoIcon2 = _interopRequireDefault(_EntypoIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var iconClass = 'entypo-svgicon entypo--Cup';

var EntypoCup = function EntypoCup(props) {
    return _react2.default.createElement(
        _EntypoIcon2.default,
        _extends({ propClass: iconClass }, props),
        _react2.default.createElement('path', { d: 'M10,1C5.721,1,3.06,2.41,3.205,3.555l1.442,13.467C4.705,17.482,6.868,18.998,10,19c3.131-0.002,5.295-1.518,5.351-1.979l1.442-13.467C16.938,2.41,14.279,1,10,1z M10,5.291C6.868,5.289,4.647,4.174,4.647,3.756C4.646,3.342,6.869,2.225,10,2.227c3.131-0.002,5.354,1.115,5.351,1.529C15.351,4.174,13.131,5.289,10,5.291z' })
    );
};

exports.default = EntypoCup;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-entypo/lib/entypo/Cup.js
// module id = ./node_modules/react-entypo/lib/entypo/Cup.js
// module chunks = 2